import React from "react";
import { Col, FormControl, FormGroup, Glyphicon, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import { Pagination } from "./Pagination";
import { PageSize } from "./PageSize";
import { MaxPageInPagination } from "./config";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import LoadingComponent from "components/LoadingComponent";

export function Grid({ columns, data, keyField, loading, ...props }) {
  const paginationOptions = {
    custom: true,
    totalSize: data.length,
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
    ],
    page: 1,
  };

  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => (
        <ToolkitProvider
          keyField={keyField}
          columns={columns}
          data={data}
          search
        >
          {(toolkitProps) => (
            <LoadingComponent isLoading={loading}>
              <Row style={{ display: "flex", alignItems: "center" }}>
                <Col sm={6}>
                  <b>{paginationProps.dataSize} items found</b>
                </Col>
                <Col sm={6}>
                  <SearchBar {...toolkitProps.searchProps} />
                </Col>
              </Row>
              <BootstrapTable
                noDataIndication="No matching records found"
                striped
                hover
                {...toolkitProps.baseProps}
                {...paginationTableProps}
                {...props}
              />
              <Row>
                <Col sm={6}>
                  <PageSize
                    options={paginationProps.sizePerPageList}
                    totalRows={paginationProps.dataSize}
                    onPageSizeChange={(value) =>
                      paginationProps.onSizePerPageChange(value, 1)
                    }
                  />
                </Col>
                <Col sm={6} style={{ textAlign: "right" }}>
                  <Pagination
                    totalRows={paginationProps.dataSize}
                    currentPage={paginationProps.page}
                    pageSize={paginationProps.sizePerPage}
                    onPageChange={paginationProps.onPageChange}
                    maxPage={MaxPageInPagination}
                  />
                </Col>
              </Row>
            </LoadingComponent>
          )}
        </ToolkitProvider>
      )}
    </PaginationProvider>
  );
}

function SearchBar({ onSearch }) {
  return (
    <Row>
      <Col sm={12} className="pull-right" style={{ maxWidth: 280 }}>
        <FormGroup className="has-feedback" style={{ marginBottom: "5px" }}>
          <FormControl
            type="text"
            placeholder="Search"
            onChange={(e) => onSearch(e.target.value)}
          />
          <FormControl.Feedback style={{ color: "#a9a9a9" }}>
            <Glyphicon glyph="search" />
          </FormControl.Feedback>
        </FormGroup>
      </Col>
    </Row>
  );
}
